import type { AdminEmailUnreadCountProps } from "../../models/admin-email.models";

// Keep an unavailable count visibly different from an empty inbox.
const AdminEmailUnreadCount = ({ count, unavailable = false, compact = false }: AdminEmailUnreadCountProps) => (
  <span
    data-test="admin-email-unread-count"
    aria-label={count === null || unavailable ? "Unread count unavailable" : `${count} unread emails`}
    className="inline-flex min-w-6 shrink-0 items-center justify-center rounded-full bg-green px-2 py-0.5 text-[11px] font-semibold leading-4 text-white"
  >
    {count === null || unavailable ? "?" : compact && count > 99 ? "99+" : count.toLocaleString()}
  </span>
);

export default AdminEmailUnreadCount;
